import { HarmonyThemeMode } from '@office-start/visual-types';
export var ConsumerNewUserUpgradeTuiItem = {
    id: 'ConsumerUpgradeTuiItem',
    type: 'item',
    callout: 'Consumer_Upgrade_Callout',
};
export var ConsumerNewUserCreateTuiItem = {
    id: 'ConsumerCreateTuiItem',
    type: 'item',
    callout: 'Create_Here_Consumer_Callout',
};
/**
 * Tui Items (Can be shared between new and returning)
 */
export var ConsumerMyContentTuiItem = {
    id: 'ConsumerMyContentSequence',
    type: 'item',
    callout: 'EdgeworthConsumer_MyContent_Callout',
    impressionEvent: "Consumer_MyContent_Sequence" /* KnownImpressionInstrumentationEvents.ConsumerMyContentSequenceImpression */,
    activationSettings: {
        impressionEvents: [
            "Consumer_MyContent_Sequence" /* KnownImpressionInstrumentationEvents.ConsumerMyContentSequenceImpression */,
        ],
        featureGates: function (gates) { var _a, _b; return (_b = (_a = gates === null || gates === void 0 ? void 0 : gates.myContentGates) === null || _a === void 0 ? void 0 : _a.myContentEnabled) !== null && _b !== void 0 ? _b : false; },
        pages: ['OfficeHome', 'Pwa'],
    },
};
export var ConsumerPinnedFavoritesTuiItem = {
    id: 'ConsumerPinnedFavoritesSequence',
    type: 'item',
    callout: 'EdgeworthConsumer_Favorites_Callout',
    impressionEvent: "Consumer_Pinned_Favorites_Sequence" /* KnownImpressionInstrumentationEvents.ConsumerPinnedFavoritesSequenceImpression */,
    activationSettings: {
        impressionEvents: [
            "Consumer_Pinned_Favorites_Sequence" /* KnownImpressionInstrumentationEvents.ConsumerPinnedFavoritesSequenceImpression */,
        ],
        featureGates: function (gates) { var _a, _b; return (_b = (_a = gates === null || gates === void 0 ? void 0 : gates.quickAccessV1Gates) === null || _a === void 0 ? void 0 : _a.quickAccessV1Enabled) !== null && _b !== void 0 ? _b : false; },
        pages: ['OfficeHome', 'Pwa'],
    },
};
var isUsingDarkMode = function (config) {
    return config.extraSequenceValidationData.themePromise.then(function (theme) { return (theme === null || theme === void 0 ? void 0 : theme.mode) === HarmonyThemeMode.Dark; });
};
export var ConsumerDarkModeStandaloneTuiItem = {
    id: 'ConsumerDarkModeTuiItem',
    type: 'standalone',
    callout: 'Visuals_DarkMode_Callout',
    impressionEvent: "Callout_Visuals_Dark_Mode_1" /* KnownImpressionInstrumentationEvents.CalloutVisualsDarkModeImpression */,
    activationSettings: {
        impressionEvents: [
            "Callout_Visuals_Dark_Mode_1" /* KnownImpressionInstrumentationEvents.CalloutVisualsDarkModeImpression */,
        ],
        pages: ['OfficeHome', 'Pwa'],
        featureGates: function (gates) {
            var _a, _b, _c;
            return ((_c = (((_a = gates.visualGates) === null || _a === void 0 ? void 0 : _a.visualDarkModeTuiEnabled) &&
                ((_b = gates.visualGates) === null || _b === void 0 ? void 0 : _b.visualSettingEnabled))) !== null && _c !== void 0 ? _c : false);
        },
        // Show if the user isn't already using dark mode
        customValidator: function (config) { return isUsingDarkMode(config).then(function (x) { return !x; }); },
        // Mark the callout as "seen" since the user is already using dark mode and knows about the feature
        markAsSeen: function (config) { return isUsingDarkMode(config); },
    },
    actionButton: {
        text: 'calloutActionButtonTryNowText',
        action: function (_a) {
            var updateHarmonyTheme = _a.updateHarmonyTheme;
            updateHarmonyTheme({ mode: HarmonyThemeMode.Dark }, 'HarmonyThemeModeChange', {
                area: 'TuiCallout',
                subArea: 'TuiActionButton',
                featureName: "TeachingUi" /* KnownFeatureNames.TeachingUi */,
            });
        },
    },
};
export var FreemiumReminderTuiItem = {
    id: 'FreemiumReminderSequence',
    type: 'item',
    callout: 'Callout_Consumer_Get_Premium',
    impressionEvent: "Callout_Consumer_Get_Premium" /* KnownImpressionInstrumentationEvents.CalloutConsumerGetPremiumImpression */,
    activationSettings: {
        impressionEvents: [
            "Callout_Consumer_Get_Premium" /* KnownImpressionInstrumentationEvents.CalloutConsumerGetPremiumImpression */,
        ],
        pages: ['OfficeHome', 'Pwa'],
        featureGates: function (gates) {
            var _a, _b;
            return ((_b = (_a = gates.freemiumTuiReminderGates) === null || _a === void 0 ? void 0 : _a.freemiumTuiReminderEnabled) !== null && _b !== void 0 ? _b : false);
        },
        customValidator: function (config) {
            return config.extraSequenceValidationData.userProfileInfoPromise.then(function (userProfileInfo) { var _a; return ((_a = userProfileInfo === null || userProfileInfo === void 0 ? void 0 : userProfileInfo.metrics.Home_PageView) === null || _a === void 0 ? void 0 : _a.count) == 3; });
        },
    },
};
//# sourceMappingURL=tui-items.js.map